module.exports = __webpack_public_path__ + "static/media/speedometer.71601f1d.svg";